import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import exact from 'prop-types-exact';
import {
  Nav,
  NavItem,
  Label,
} from 'react-bootstrap';

import { getCurrentSubmissionId } from '../selectors';
import { setCurrentSubmissionId } from '../actions';

const propTypes = exact({
  /* eslint-disable react/no-unused-prop-types */
  currentSubmissionItemId: PropTypes.number.isRequired,
  setCurrentSubmissionIdAction: PropTypes.func.isRequired,

  uniqueSubmissionIds: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  allTimeEntries: PropTypes.array.isRequired,

  userId: PropTypes.number.isRequired,
  submissionItemId: PropTypes.number.isRequired,
  originDate: PropTypes.string.isRequired,
  /* eslint-enable react/no-unused-prop-types */
});


const SubmissionItemNav = (props) => {
  const {
    uniqueSubmissionIds,
    setCurrentSubmissionIdAction,
    currentSubmissionItemId,
    user,
  } = props;

  const renderTab = (submissionObj) => {
    const { id, date } = submissionObj;
    const isActiveStyle = (id === currentSubmissionItemId)
      ? { backgroundColor: '#337ab7' } : {};
    return (
      <NavItem
        key={id}
        eventKey={id}
        onClick={() => { setCurrentSubmissionIdAction(id); }}
      >
        <Label style={isActiveStyle}>{date}</Label>
      </NavItem>
    );
  };

  return (
    <React.Fragment>
      <h3>Employee: {user.fullname}</h3>
      <Nav bsStyle="tabs" activeKey={currentSubmissionItemId}>
        {uniqueSubmissionIds.map(renderTab, this)}
      </Nav>
    </React.Fragment>
  );
};


SubmissionItemNav.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    currentSubmissionItemId: getCurrentSubmissionId(state),
  };
};

const mapDispatchToProps = {
  setCurrentSubmissionIdAction: setCurrentSubmissionId,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(SubmissionItemNav);
